import { defineStore } from "pinia";
import { ref } from "vue";
import { storage, STORAGE_KEYS } from "@/api/utils/localStorage";

export interface FavoritesToken {
	address: string;
	name: string;
	verify: boolean;
	image: string;
}

export const useFavoritesStore = defineStore("favorites", () => {
	const favorites = ref<FavoritesToken[]>([]);

	// Initialize from localStorage with type safety
	const initializeFavorites = () => {
		const storedData = storage.get(STORAGE_KEYS.FAVORITES, "[]");
		try {
			const parsedData = JSON.parse(storedData);

			favorites.value = Array.isArray(parsedData) ? parsedData : [];
		} catch (error) {
			console.error("Failed to parse favorites:", error);
			favorites.value = [];
		}
	};

	const isFavorite = (address: string) =>
		favorites.value?.some((token) => address && token?.address && token?.address === address);

	const toggleFavorite = (token: FavoritesToken) => {
		const index = favorites.value.findIndex((t) => t.address === token.address);
		if (index === -1) {
			favorites.value.push(token);
		} else {
			favorites.value.splice(index, 1);
		}

		// Fix: use favorites.value to get the actual array
		storage.set(STORAGE_KEYS.FAVORITES, JSON.stringify(favorites.value));
	};

	// Initialize immediately, not just on mount
	initializeFavorites();

	return {
		favorites,
		isFavorite,
		toggleFavorite,
		initializeFavorites,
	};
});

export type FavoritesStore = ReturnType<typeof useFavoritesStore>;